/**
 * Utility functions for managing document titles
 */

/**
 * Sets the document title with a consistent format
 * @param {string} pageTitle - The specific page title
 */
export const setDocumentTitle = (pageTitle) => {
    if (pageTitle) {
        document.title = `${pageTitle} | Faraone Hub`;
    } else {
        document.title = 'Faraone Hub';
    }
};